/**
 * PriorityBadge — pill showing HIGH / MEDIUM / LOW with color coding.
 */
interface PriorityBadgeProps {
  priority: string;
}

const COLORS: Record<string, string> = {
  HIGH: 'bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300',
  MEDIUM: 'bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300',
  LOW: 'bg-green-100 dark:bg-green-900/40 text-green-700 dark:text-green-300',
  UNKNOWN: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300',
};

export function PriorityBadge({ priority }: PriorityBadgeProps): React.ReactElement {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${COLORS[priority] || COLORS.UNKNOWN}`}>
      {priority}
    </span>
  );
}
